export default "__VITE_ASSET__58fb892b__"